// extracted by mini-css-extract-plugin
export default {"editAccountButton":"styles_editAccountButton__XO5UN","contactInfo":"styles_contactInfo__z3jx6"};